import { gql } from '@/features/graphql/generated'

export const OrderDraftPricesFragment = gql(/* GraphQL */ `
    fragment OrderDraftPrices on OrderDraft {
        productsPrice {
            amount
            currency
        }
        deliveryPrice {
            amount
            currency
        }
        smallOrderSurcharge {
            amount
            currency
        }
        containerFee {
            amount
            currency
        }
        totalPrice {
            amount
            currency
        }
    }
`)
